import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Button, CloseButton, Dialog, Field, Input, Portal, Show, SimpleGrid, Tabs, Text,} from "@chakra-ui/react"
import {useToast} from "@chakra-ui/toast";
import {useRecoilState} from "recoil";
import {companiesData, companyData, companyOperatorsData, executorData, profileData, useCleanData, userLoginResultData} from "./hooks/recoilData";
import {dataApi} from "../api/data-api";
import {LuGroup, LuUser} from "react-icons/lu";
import {userApi} from "../api/user-api";
import {errorNotify, sleep} from "./hooks/CommonUtils";

interface DataCompanyParams {
    name: string,
    nameFull: string,
    address: string,
    addressActual: string,
    codeInn: string,
    codeKPP: string,
    codeOGRN: string,
    email: string,
    tel: string
}

interface DataExecutorParams {
    // nalogId: string,
    codeInn: string,
    firstName: string,
    secondName: string,
    lastName: string,
}

interface DataOperatorParams {
    codeInn: string,
}

export default function InitDlg(props: {}) {
    const [profile] = useRecoilState(profileData);
    const inputCompanyDefault: DataCompanyParams = useMemo(() => {
        return {
            name: "",
            nameFull: "",
            address: "",
            addressActual: "",
            codeInn: "",
            codeKPP: "",
            codeOGRN: "",
            email: "",
            tel: ""
        }
    }, []);
    const inputExecutorDefault: DataExecutorParams = useMemo(() => {
        return {
            // nalogId: "",
            codeInn: "",
            firstName: "",
            secondName: "",
            lastName: "",
        }
    }, []);

    const inputOperatorDefault: DataOperatorParams = useMemo(() => {
        return {
            codeInn: "",
        }
    }, []);

    const [inputCompanyParams, setInputCompanyParams] = useState<DataCompanyParams>(inputCompanyDefault);
    const [inputExecutorParams, setInputExecutorParams] = useState<DataExecutorParams>(inputExecutorDefault);
    const [inputOperatorParams, setInputOperatorParams] = useState<DataOperatorParams>(inputOperatorDefault);
    const [inputType, setInputType] = useState<1 | 2 | 3>(1);

    useEffect(() => {
        setInputExecutorParams({
            // nalogId: "",
            codeInn: profile ? profile.CODE_INN : "",
            firstName: profile ? profile.FIRST_NAME : "",
            secondName: profile ? profile.SECOND_NAME : "",
            lastName: profile ? profile.LAST_NAME : "",
        });
        setInputOperatorParams({
            codeInn: profile ? profile.CODE_INN : "",
        });
    }, [profile]);

    const toast = useToast();
    const [, setExecutor] = useRecoilState(executorData);
    const [, setCompany] = useRecoilState(companyData);
    const [, setCompanies] = useRecoilState(companiesData);
    const [, setCompanyOperators] = useRecoilState(companyOperatorsData);
    const [cleanData] = useCleanData();
    const [showConfirmationDlg, setShowConfirmationDlg] = useState<boolean>(false);
    const [showDlg, setShowDlg] = useState<boolean>(false);
    const [userLoginResult] = useRecoilState(userLoginResultData);

    useEffect(() => {
        if (userLoginResult && !userLoginResult.isOperator && !userLoginResult.isEmployer && !userLoginResult.isExecutor)
            setShowDlg(true);
    }, [userLoginResult]);

    const logout = useCallback(() => {
        sleep(3000)
            .then(o => userApi.logout())
            .then((o) => cleanData())
            .catch((err) => errorNotify(err, toast));
    }, [cleanData, toast]);

    const enterExecutor = useCallback(() => {
        setInputType(1);
        setShowDlg(false);
        setShowConfirmationDlg(true);
    }, []);

    const enterCompany = useCallback(() => {
        setInputType(2);
        setShowDlg(false);
        setShowConfirmationDlg(true);
    }, []);

    const enterOperator = useCallback(() => {
        setInputType(3);
        setShowDlg(false);
        setShowConfirmationDlg(true);
    }, []);

    const cancel = useCallback(() => {
        setShowConfirmationDlg(false);
        setShowDlg(false);
        toast({title: "Init canceled", status: "warning"});
    }, [toast]);

    const confirmConfirmationDlg = useCallback(() => {
        if (inputType === 1) {
            dataApi.executorReg(inputExecutorParams.codeInn, inputExecutorParams.firstName, inputExecutorParams.secondName, inputExecutorParams.lastName)
                .then((value) => {
                    setShowConfirmationDlg(false);
                    setExecutor(value);
                    // setInputExecutorParams(inputExecutorDefault);
                    toast({title: "Init", description: "executor registered", status: "success"});
                    if (profile && (inputExecutorParams.firstName !== profile.FIRST_NAME || inputExecutorParams.secondName !== profile.SECOND_NAME ||
                        inputExecutorParams.lastName !== profile.LAST_NAME || inputExecutorParams.codeInn !== profile.CODE_INN)) {
                        userApi.profileOwnEdit(
                            profile.NICK_NAME, inputExecutorParams.firstName, inputExecutorParams.secondName, inputExecutorParams.lastName, profile.DESCRIPTION, profile.TEL, profile.COUNTRY, profile.IMAGE,
                            profile.SEX, profile.DATE_OF_BIRTH, profile.PASS_NUMBER, profile.PASS_DATE, profile.PASS_DEPARTMENT_CODE, profile.PASS_DEPARTMENT, profile.PASS_PLACE_OF_BIRTH,
                            profile.PASS_ADDRESS, inputExecutorParams.codeInn, profile.CODE_KPP, profile.CODE_SNILS)
                            .then((o3) => {
                                toast({title: "Profile change", status: "success"});
                            })
                            .catch((err) => errorNotify(err, toast));
                    }
                    logout();
                })
                .catch((err) => errorNotify(err, toast));
        } else if (inputType === 2) {
            dataApi.companyReg(inputCompanyParams.name, inputCompanyParams.nameFull, inputCompanyParams.address, inputCompanyParams.addressActual,
                inputCompanyParams.codeInn, inputCompanyParams.codeKPP, inputCompanyParams.codeOGRN, inputCompanyParams.email, inputCompanyParams.tel)
                .then((value) => {
                    setShowConfirmationDlg(false);
                    setCompany(value);
                    setCompanies([value]);
                    // setInputCompanyParams(inputCompanyDefault);
                    toast({title: "Init", description: `wait call from as`, status: "success"});
                    logout();
                })
                .catch((err) => errorNotify(err, toast));
        } else if (inputType === 3) {
            dataApi.operatorReg(inputOperatorParams.codeInn)
                .then((value) => {
                    setShowConfirmationDlg(false);
                    dataApi.operatorListOwn()
                        .then((value2) => {
                            setCompanyOperators(value2);
                        })
                        .catch((err) => errorNotify(err, toast));
                    // setInputExecutorParams(inputExecutorDefault);
                    toast({title: "Init", description: "operator registered", status: "success"});
                    if (profile && (inputOperatorParams.codeInn !== profile.CODE_INN)) {
                        userApi.profileOwnEdit(
                            profile.NICK_NAME, profile.FIRST_NAME, profile.SECOND_NAME, profile.LAST_NAME, profile.DESCRIPTION, profile.TEL, profile.COUNTRY, profile.IMAGE,
                            profile.SEX, profile.DATE_OF_BIRTH, profile.PASS_NUMBER, profile.PASS_DATE, profile.PASS_DEPARTMENT_CODE, profile.PASS_DEPARTMENT, profile.PASS_PLACE_OF_BIRTH,
                            profile.PASS_ADDRESS, inputOperatorParams.codeInn, profile.CODE_KPP, profile.CODE_SNILS)
                            .then((o3) => {
                                toast({title: "Profile change", status: "success"});
                            })
                            .catch((err) => errorNotify(err, toast));
                    }
                    logout();
                })
                .catch((err) => errorNotify(err, toast));
        }
    }, [setShowConfirmationDlg, toast, inputExecutorParams, setExecutor, profile, logout, inputType, inputCompanyParams, inputOperatorParams, setCompanies, setCompany, setCompanyOperators]);

    return (
        <>
            <Dialog.Root open={showDlg} onOpenChange={cancel}>
                <Dialog.Trigger/>
                <Portal>
                    <Dialog.Backdrop/>
                    <Dialog.Positioner>
                        <Dialog.Content>
                            <Dialog.Header>
                                <Dialog.Title>The last stage of registration</Dialog.Title>
                            </Dialog.Header>
                            <Dialog.Body>
                                <Tabs.Root defaultValue="executor">
                                    <Tabs.List>
                                        <Tabs.Trigger value="executor">
                                            <LuUser/>
                                            Исполнитель
                                        </Tabs.Trigger>
                                        <Tabs.Trigger value="company">
                                            <LuGroup/>
                                            Компания
                                        </Tabs.Trigger>
                                        <Tabs.Trigger value="operator">
                                            <LuGroup/>
                                            Оператор
                                        </Tabs.Trigger>
                                    </Tabs.List>
                                    <Tabs.Content value="executor">
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>ИНН <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="ИНН"
                                                   value={inputExecutorParams.codeInn}
                                                   onChange={(it) => setInputExecutorParams(prev => {
                                                       return {...prev, codeInn: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>Имя <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="Имя"
                                                   value={inputExecutorParams.firstName}
                                                   onChange={(it) => setInputExecutorParams(prev => {
                                                       return {...prev, firstName: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>Отчество <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="Отчество"
                                                   value={inputExecutorParams.secondName}
                                                   onChange={(it) => setInputExecutorParams(prev => {
                                                       return {...prev, secondName: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>Фамилия <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="Фамилия"
                                                   value={inputExecutorParams.lastName}
                                                   onChange={(it) => setInputExecutorParams(prev => {
                                                       return {...prev, lastName: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        {/*<Field.Root orientation="horizontal">*/}
                                        {/*    <Field.Label>nalogId <Field.RequiredIndicator/></Field.Label>*/}
                                        {/*    <Input type="text" placeholder="nalogId"*/}
                                        {/*           value={inputExecutorParams.nalogId}*/}
                                        {/*           onChange={(it) => setInputExecutorParams(prev => {*/}
                                        {/*               return {...prev, nalogId: it.target.value};*/}
                                        {/*           })}/>*/}
                                        {/*</Field.Root>*/}
                                        <Button onClick={enterExecutor}>Enter</Button>
                                    </Tabs.Content>
                                    <Tabs.Content value="company">
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>Имя <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="Имя"
                                                   value={inputCompanyParams.name}
                                                   onChange={(it) => setInputCompanyParams(prev => {
                                                       return {...prev, name: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>Полное имя <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="Полное имя"
                                                   value={inputCompanyParams.nameFull}
                                                   onChange={(it) => setInputCompanyParams(prev => {
                                                       return {...prev, nameFull: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>Юридический адресс <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="Юридический адресс"
                                                   value={inputCompanyParams.address}
                                                   onChange={(it) => setInputCompanyParams(prev => {
                                                       return {...prev, address: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>Фактический адресс <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="Фактический адресс"
                                                   value={inputCompanyParams.addressActual}
                                                   onChange={(it) => setInputCompanyParams(prev => {
                                                       return {...prev, addressActual: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>ИНН <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="ИНН"
                                                   value={inputCompanyParams.codeInn}
                                                   onChange={(it) => setInputCompanyParams(prev => {
                                                       return {...prev, codeInn: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>КПП <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="КПП"
                                                   value={inputCompanyParams.codeKPP}
                                                   onChange={(it) => setInputCompanyParams(prev => {
                                                       return {...prev, codeKPP: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>ОГРН <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="ОГРН"
                                                   value={inputCompanyParams.codeOGRN}
                                                   onChange={(it) => setInputCompanyParams(prev => {
                                                       return {...prev, codeOGRN: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>Email <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="Email"
                                                   value={inputCompanyParams.email}
                                                   onChange={(it) => setInputCompanyParams(prev => {
                                                       return {...prev, email: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>Телефон <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="Телефон"
                                                   value={inputCompanyParams.tel}
                                                   onChange={(it) => setInputCompanyParams(prev => {
                                                       return {...prev, tel: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Button onClick={enterCompany}>Enter</Button>
                                    </Tabs.Content>
                                    <Tabs.Content value="operator">
                                        <Field.Root orientation="horizontal" required>
                                            <Field.Label>ИНН <Field.RequiredIndicator/></Field.Label>
                                            <Input type="text" placeholder="ИНН"
                                                   value={inputOperatorParams.codeInn}
                                                   onChange={(it) => setInputOperatorParams(prev => {
                                                       return {...prev, codeInn: it.target.value};
                                                   })}/>
                                        </Field.Root>
                                        <Button onClick={enterOperator}>Enter</Button>
                                    </Tabs.Content>
                                </Tabs.Root>
                            </Dialog.Body>
                            <Dialog.Footer>
{/*
                                <Dialog.ActionTrigger asChild>
                                    <Button variant="outline" onClick={cancel}>Отмена</Button>
                                </Dialog.ActionTrigger>
*/}
                            </Dialog.Footer>
                            <Dialog.CloseTrigger asChild>
                                <CloseButton size="sm" onClick={cancel}/>
                            </Dialog.CloseTrigger>
                        </Dialog.Content>
                    </Dialog.Positioner>
                </Portal>
            </Dialog.Root>

            <Dialog.Root open={showConfirmationDlg} onOpenChange={cancel}>
                <Dialog.Trigger/>
                <Portal>
                    <Dialog.Backdrop/>
                    <Dialog.Positioner>
                        <Dialog.Content>
                            <Dialog.Header>
                                <Dialog.Title>Подтверждение</Dialog.Title>
                            </Dialog.Header>
                            <Dialog.Body>
                                <Show when={inputType === 1}>
                                    <SimpleGrid columns={[2]} gap={3}>
                                        <Text>ИНН</Text>
                                        <Text>{inputExecutorParams.codeInn}</Text>
                                        <Text>Имя</Text>
                                        <Text>{inputExecutorParams.firstName}</Text>
                                        <Text>Отчество</Text>
                                        <Text>{inputExecutorParams.secondName}</Text>
                                        <Text>Фамилия</Text>
                                        <Text>{inputExecutorParams.lastName}</Text>
                                    </SimpleGrid>
                                </Show>
                                <Show when={inputType === 2}>
                                    <SimpleGrid columns={[2]} gap={3}>
                                        <Text>Имя</Text>
                                        <Text>{inputCompanyParams.name}</Text>
                                        <Text>Полное имя</Text>
                                        <Text>{inputCompanyParams.nameFull}</Text>
                                        <Text>Юридический адресс</Text>
                                        <Text>{inputCompanyParams.address}</Text>
                                        <Text>Фактический адресс</Text>
                                        <Text>{inputCompanyParams.addressActual}</Text>
                                        <Text>ИНН</Text>
                                        <Text>{inputCompanyParams.codeInn}</Text>
                                        <Text>КПП</Text>
                                        <Text>{inputCompanyParams.codeKPP}</Text>
                                        <Text>ОГРН</Text>
                                        <Text>{inputCompanyParams.codeOGRN}</Text>
                                        <Text>Email</Text>
                                        <Text>{inputCompanyParams.email}</Text>
                                        <Text>Телефон</Text>
                                        <Text>{inputCompanyParams.tel}</Text>
                                    </SimpleGrid>
                                </Show>
                                <Show when={inputType === 3}>
                                    <SimpleGrid columns={[2]} gap={3}>
                                        <Text>ИНН</Text>
                                        <Text>{inputOperatorParams.codeInn}</Text>
                                    </SimpleGrid>
                                </Show>
                                <Text>Подтвердить?</Text>
                            </Dialog.Body>
                            <Dialog.Footer>
                                <Dialog.ActionTrigger asChild>
                                    <Button variant="outline" onClick={cancel}>Отмена</Button>
                                </Dialog.ActionTrigger>
                                <Button onClick={confirmConfirmationDlg}>Подтвердить</Button>
                            </Dialog.Footer>
                            <Dialog.CloseTrigger asChild>
                                <CloseButton size="sm" onClick={cancel}/>
                            </Dialog.CloseTrigger>
                        </Dialog.Content>
                    </Dialog.Positioner>
                </Portal>
            </Dialog.Root>
        </>
    );
}